import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { NewRelicService } from '../../../../../../../angular-app/projects/brokerage-eapp/src/app/services/newrelic.service';
import { FormGroup, ControlContainer, ControlValueAccessor } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import { first, distinctUntilChanged, map, debounceTime, takeUntil } from 'rxjs/operators';

import { AppState } from '../../app-reducer';
import { ProcessorService } from '../../services/processor.service';
import { NavigationService } from '../../services/navigation.service';
import { QuestionControlService } from '../../services/question-control.service';
import { optionsMap } from 'src/app/models/options-map';
import { clone, cloneDeep, find, forEach, get, isArray, isEmpty, isEqual } from 'lodash';

import { QuestionService } from '../../services/question.service';

@Component({
  selector: 'multiple-response',
  templateUrl: './multiple-response.component.html'
})
export class MultipleResponseComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() parent: FormGroup;
  @Input() childQuestions: any;
  @Input() formGroupName: any;
  @Input() isEditable: boolean;
  @Input() toggleOpenFields: boolean;
  @Output() remove: EventEmitter<any> = new EventEmitter<any>();
  public baseFormGroup: FormGroup;
  public parentFormGroup: FormGroup;
  public grandChildQuestions: any;
  appState$: Observable<any>;
  questions: any;
  label: string;
  textNumber = ['One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen', 'Twenty'];
  sectionBlock: string;
  questionsAll: any;
  formVal: any;
  sectionMenuData: any;
  visibleQuestions: any;
  onChange: any = () => { };
  onTouched: any = () => { };
  arrayLengthVulFundOther = 0;
  arrayLengthVULSegmentFromBCIA = 0;
  arrayLengthVULSegmentFromBHPCIA = 0;
  //JIRA: 3476 Begin
  arrayLengthVULSegmentFromBCTYIA = 0;
  arrayLengthVULSegmentFromHCIA = 0;
  //JIRA: 3476 End
  arrayLengthVULAllocationofMonthlyCharges = 0;
  arrayLengthAccountBalancer = 0;
  totalAllocation: any = 0;
  private _onDestroy = new Subject();
  enabledQuestions: any[] = [];
  userRole: any;
  isDemo: false;
  vulAccountQnSet = {
    'VULAllocationMonthlyChargesAccount': 'VULAllocationMonthlyChargesAccountPercent',
    'VULSegmentFromBCIAAccount': 'VULSegmentFromBCIAPercent',
    'VULSegmentFromBHPCIAAccount': 'VULSegmentFromBHPCIAPercent',
    'VULSegmentFromBCTYIAAccount': 'VULSegmentFromBCTYIAPercent',
    'VULSegmentFromHCIAAccount': 'VULSegmentFromHCIAPercent',
    'AccountBalancerName' : 'AccountBalancerPercentage'
  }
  appId: string;

  constructor(
    private newRelicService: NewRelicService,
    private controlContainer: ControlContainer,
    private qs: QuestionService,
    private processorService: ProcessorService,
    private navigationService: NavigationService,
    private qcs: QuestionControlService,
    public route: ActivatedRoute,
    private store: Store<AppState>,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.newRelicService.addPageAction('multi-response ngOnInit Start', { status: 'started' });

    this.baseFormGroup = <FormGroup>this.controlContainer.control;
    this.parentFormGroup = <FormGroup>this.parent;
    this.appState$ = this.store.select('sections');

    this.label = get(optionsMap[this.childQuestions[0].ParentQuestionName], 'multiResponseLabel');

    this.sectionBlock = this.route.snapshot.data.blockName;

    // get questions from state
    this.appState$.pipe(
      first()
    ).subscribe((state: any) => {
      this.appId = state.appId;
      if (state.questions) {
        this.questions = find(state.questions, { Name: this.sectionBlock }).Questions;
      }
      this.userRole = state.userRole;

      this.isEditable = this.isEditable == null ? true : this.isEditable;

      this.questionsAll = state.questions;

      this.sectionMenuData = find(state.content.menuData, { name: this.sectionBlock });

      this.isDemo = state.isDemo;
    });

    if (this.childQuestions[0].ParentQuestionName === 'VULFundOtherOptionsCompound') {
      this.vulTotalAllocations();
    }
    if (this.childQuestions[0].ParentQuestionName === 'VULSegmentFromBCIACompound') {
      this.vulBCIATotalAllocations();
    }
    if (this.childQuestions[0].ParentQuestionName === 'VULSegmentFromBHPCIACompound') {
      this.vulBHPCIATotalAllocations();      
    }
    //JIRA: 3476 Begin
    if (this.childQuestions[0].ParentQuestionName === 'VULSegmentFromBCTYIACompound') {
      this.vulBCTYIATotalAllocations();
          }
    if (this.childQuestions[0].ParentQuestionName === 'VULSegmentFromHCIACompound') {
      this.vulHCIATotalAllocations();
    }
    //JIRA: 3476 End
    if (this.childQuestions[0].ParentQuestionName === 'VULAllocationofMonthlyChargesCompound') {
      this.vulMonthlyChargesTotalAllocations();
    }
    if (this.childQuestions[0].ParentQuestionName === 'AccountBalancerCompound') {
      this.vulAccountBalancerTotalAllocations();
    }
    this.formVal = cloneDeep(this.baseFormGroup.value);
    this.visibleQuestions = cloneDeep(this.baseFormGroup.value);

    this.enabledQuestions = this.qs.filterMultiResponseRestrictedQuestions(this.questions, this.userRole.name, this.isDemo);
    //console.log('multiresponse enabled questions:', this.enabledQuestions);

    this.newRelicService.addPageAction('multi-response ngOnInit End', { status: 'completed', appId: this.appId });
  }

  ngAfterViewInit() {
    this.newRelicService.addPageAction('multi-response ngAfterViewInit Start', { status: 'started', appId: this.appId });

    if (!this.isEditable) {
    //console.log('trying to disable fields'); 
      window['setTimeout'](() => {
        this.disableFields();
      }, 1500);
    }

    // statusChanges here is being used as a trigger to run a check for whether the add multiple response button (located in dynamic-form-question.component) should be enabled or disabled
    if (!this.isEditable) {
      this.baseFormGroup.statusChanges.pipe(debounceTime(300), distinctUntilChanged(), takeUntil(this._onDestroy)).subscribe(status => {

        const enabledSet = Object.keys(this.baseFormGroup.controls).filter(q => this.baseFormGroup.get(q).enabled);
        //console.log('enabledSet', enabledSet);
        const visibleQsRemaining = Object.keys(this.visibleQuestions).filter(q => this.visibleQuestions[q]);
        //console.log('visibleQsRemaining', visibleQsRemaining);
        if (visibleQsRemaining.every(q => enabledSet.includes(q)) || this.isDemo && visibleQsRemaining.some( q =>enabledSet.includes(q))) {
          this.navigationService.disableMultipleReponseButton(false);
        } else {
          this.navigationService.disableMultipleReponseButton(true);
        }
      });
    }  else {
      this.navigationService.disableMultipleReponseButton(false);
    }

    this.baseFormGroup.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(x => {
      const newFormVal = cloneDeep(x);

      if (isEqual(this.formVal, newFormVal)) {
        return;
      } else if (this.formVal) {
        const diff = Object.keys(newFormVal).filter(k => newFormVal[k] != this.formVal[k]);
        if (diff.length > 0) {
          // console.log(diff, 'changed');
          diff.forEach(changedQuestion => {
            const question = this.qcs.getQuestion(this.questions, changedQuestion);
           

            // prevents analysing conditionality of questions that have data entered but aren't valid (stops repeated unecessary checks)
             if (this.baseFormGroup.controls[changedQuestion.toString().split('.').pop()].dirty && (!this.baseFormGroup.controls[changedQuestion.toString().split('.').pop()].valid || this.baseFormGroup.controls[changedQuestion.toString().split('.').pop()].value == '$')) {
              return;
            }
            if (question && question.ConditionalClause) {
              this.visibleQuestions[changedQuestion] = null;
            }
            if (question && question.ConditionalDependents) {
              this.checkConditionalDependents(question);
            }
          });
        }
      }
      this.formVal = newFormVal;
    });

    this.newRelicService.addPageAction('multi-response ngAfterViewInit End', { status: 'completed', appId: this.appId });
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this.formVal = null;
  }

  isQuestionVisible(question) {
    //nested conditional questions that need additional checking
    const nestedConditionalQuestions = ['TrusteeType', 'SigningOfficerSoleSigner'];
    if (this.visibleQuestions[question.QuestionName] === null || (isArray(this.visibleQuestions[question.QuestionName]) && this.visibleQuestions[question.QuestionName].every(x => x !== true)) || question.QuestionName.includes('NIGOWarning') ||  nestedConditionalQuestions.includes(question.QuestionName)) {
      if (question.QuestionName=='FamilyHistoryConditionCancer'){
        console.log('did we hit? FamilyHistoryConditionCancer')
      }
      this.showConditionalQuestion(question);
    }
    // work-around for forced reflow issue that resets formControls but not visibleQuestions, resulting in incorrect invalids
    if (!this.visibleQuestions[question.QuestionName]) {
      this.baseFormGroup.controls[question.QuestionName].disable();
    }
    return this.visibleQuestions[question.QuestionName] ? true : false;
  }

  removeDetail() {
    this.remove.emit(this.formGroupName);
  }

  getChildQuestions(question: any) {
    return this.qcs.getChildQuestions(question, this.questions, true);
  }

  isNotMultipleResponseChild(question) {
    const { ParentQuestionName } = question;
    const pq = find(this.childQuestions, { QuestionName: ParentQuestionName});
    if (pq && pq.MultipleResponse === true) {
      return false;
    } else {
      return true;
    }
  }

  checkConditionalDependents(question) {
    const dependentQuestions = question.ConditionalDependents;
    dependentQuestions.forEach(q => {
      if (q.toString().toLowerCase().includes(this.sectionBlock.toLowerCase() + '.')) {
        q = q.toString().split('.').pop();
        this.visibleQuestions[q] = null;
      } else {
        const cue = q.toString().split('.');
        const section: any = find(this.questionsAll, { Name: cue[0] });
        this.appState$.pipe(first()).subscribe((state: any) => {
          const menuData = state.content.menuData;
          const offBlock = find(menuData, { name: cue[0] });
          if (typeof offBlock === 'undefined' || isEmpty(offBlock.questions)) {
          } else {
            const offBlockQ = find(offBlock.questions, { name: cue[1] });
            const fullQuestion = this.qcs.getQuestion(section.Questions, cue[1]);
            let showNow: boolean;
            const ancestors = this.getLineage(fullQuestion, section.Questions, []);
            for (let i = 0; i < ancestors.length; i++) {
              if (!ancestors[i].ConditionalClause) {
                showNow = true;
              } else {
              //  this.processorService.enableComments(ancestors[i].QuestionName === 'IULProceedsAlloc' ? true : false);

               // this.processorService.enableComments(ancestors[i].QuestionName === 'IULProceedsAllocToCompound' ? true : false);
                showNow = this.processorService.showConditionalQuestion(ancestors[i], section.Questions, this.baseFormGroup.getRawValue(), this.parentFormGroup.value);
              }
              if (!showNow) {
                break;
              }
            };
            if (!offBlockQ.visible) {
              if (showNow) {
                offBlockQ.visible = true;
                offBlockQ.valid = false;
              } else {
                offBlockQ.visible = false;
                offBlockQ.valid = null;
              }
            } else {
              offBlockQ.visible = showNow;
              offBlockQ.valid = this.checkOffBlockQuestionValidity(fullQuestion, section.Name);
            }
          }
        });
      }
    });
  }

  disableFields() {
    this.baseFormGroup.disable();
    if (this.toggleOpenFields && this.enabledQuestions.length > 0) {
      forEach(this.enabledQuestions, q => {
        //console.log('q: ', q);
        //console.log('this.baseFormGroup.get(q): ', this.baseFormGroup.get(q));
         if (this.baseFormGroup.get(q)) 
        {
          const fullQuestion = this.questions.filter(item => item.QuestionName == q);

          if (this.isDemo && fullQuestion[0].QuestionType == 'Address'){ 
              this.baseFormGroup.get(q)['controls']['State'].enable();
              this.baseFormGroup.get(q)['controls']['Zip'].enable();
          }else{
              console.log('multiple resposne enabling: ', q);
              this.baseFormGroup.get(q).enable();
            }
        }
      });
    }
  }

  getLineage(object, questions, array) {
    array.push(object);
    const { ParentQuestionName } = object;
    if (ParentQuestionName) {
      const question = find(questions, { QuestionName: ParentQuestionName});
      this.getLineage(question, questions, array);
    }
    return array;
  }

  checkOffBlockQuestionValidity(question, sectionName) {
    let result: boolean;
    this.newRelicService.addPageAction('checkOffBlockQuestionValidity Start', { status: 'started' });

    this.appState$.pipe(first()).subscribe((state: any) => {
      if (state.content[sectionName]) {
        const val = cloneDeep(state.content[sectionName][question.QuestionName]);
        if (question.QuestionOptions.length > 0) {
          const selectedOption = question.QuestionOptions.find(item => item.key === val);
          if (selectedOption) {
            console.log('selectedOption ', selectedOption);
            if (selectedOption.ConditionalClause) {
              const stillGood = this.processorService.showConditionalOption(selectedOption.ConditionalClause, this.baseFormGroup.getRawValue());
              // deepcode ignore FormatString: this is logging validity of question. not logging pii
              console.log(question.QuestionName, 'still good? ', stillGood);
              if (stillGood === false) {
                state.content[sectionName][question.QuestionName] = null;
                this.parentFormGroup.get(question.QuestionName).patchValue(null);
                this.parentFormGroup.updateValueAndValidity();
                console.log('patching null to ', question.QuestionName);
                result = false;
              } else {
                result = true;
              }
            } else {
              result = true;
            }
          }
        } else {
          if (question.validators.length === 0) {
            result = true;
          } else {
            // console.log('need to check these validators:', question.validators);
            result = true;
          }
        }
      } else {
        result = null;
      }
    }, (error) => {
      this.newRelicService.noticeError(error, { appId: this.appId });
    });

    this.newRelicService.addPageAction('checkOffBlockQuestionValidity End', { status: 'completed', appId: this.appId });
    return result;
  }

  /**
   * Check ConditionalClause then ParentQuestion ConditionalClause if available.
   * @param question - question object
   * @returns boolean
   */
  showConditionalQuestion(question, parentShown:boolean = true, offBlockQuestions?) {
    const { QuestionName, ConditionalClause } = question;
    this.newRelicService.addPageAction('showConditionalQuestion Start', { status: 'started', question: question, appId: this.appId });

    if (parentShown) {
      // enable console logs for debuggiong all questions (proceed with caution):
      // this.processorService.enableComments(true);
      // enable console logs for debuggiong a specific question:
      // this.processorService.enableComments(QuestionName === 'PolicyOwnerAddressNIGOWarning' ? true : false);

      if (ConditionalClause === '0') {
        this.visibleQuestions[QuestionName] = false;
        return false;
      }

      // Populate QuestionTextAlt based on AlternativeQuestionText ConditionalClause
      if (question.QuestionVariations) {
        question.QuestionVariations.forEach(cond => {
          if (this.processorService.analyzeConditionalArray(cond.ConditionalClause, this.questions, this.baseFormGroup.getRawValue())) {
            question.QuestionTextAlt = cond.AlternativeQuestionText ? cond.AlternativeQuestionText : " ";
            return;
          }
        });
      }

      // Populate OptionAltText based on QuestionOptionVariations ConditionalClause
      if (question.QuestionOptions) {
        if (this.baseFormGroup.get(question.QuestionName) && this.baseFormGroup.controls[question.QuestionName].value){
          //check if the question option still exists!
          const selectedOption = question.QuestionOptions.find(item => item.Name === this.baseFormGroup.controls[question.QuestionName].value.toString());
          if (selectedOption && selectedOption.ConditionalClause) {
              const stillGood = this.processorService.analyzeConditionalArray(selectedOption.ConditionalClause, this.questions, this.baseFormGroup.getRawValue(), this.parentFormGroup.getRawValue())
            if (stillGood === false) {
              this.baseFormGroup.get(QuestionName).patchValue(null);
            }
          }
        }
        question.QuestionOptions.forEach(cond => {
          if (cond.QuestionOptionVariations) {
            cond.QuestionOptionVariations.forEach((variation) => {
              if (this.processorService.analyzeConditionalArray(variation.ConditionalClause, this.questions, this.baseFormGroup.getRawValue())) {
                cond.OptionAltText = variation.AlternativeQuestionOptionText ? variation.AlternativeQuestionOptionText : " ";
              }
            });
          }
        });
      }
    }

    let show: boolean = parentShown;
    if (show && question.ConditionalClause) {
      // this.processorService.enableComments(question.QuestionName === 'ExistingPolicyDetails' ? true : false);
      show = this.processorService.showConditionalQuestion(question, this.questions, this.baseFormGroup.getRawValue(), this.parentFormGroup.value);
    }

    const field = this.baseFormGroup.get(QuestionName);
    if (field) {
      if (show === false) {
        field.reset();
        field.disable();
      } else if (this.isDemo && (question.QuestionName == 'DriversLicenseNumber' || question.QuestionName == 'BeneficiaryName' || question.QuestionName == 'BeneficiarySSN' || question.QuestionName == 'BeneficiaryTaxID')){
        field.disable();
      } else if (this.isEditable || (!this.isEditable && this.enabledQuestions.includes(question.QuestionName))) {
        field.enable();
      }
      field.updateValueAndValidity();
    }

    // Ugly work-arounds for 11th hour issues
    if (this.baseFormGroup.get('InsuredOther') && this.baseFormGroup.controls['InsuredOther'].enabled && question.QuestionName === 'ExistingPolicy1035Exchange') {
      this.visibleQuestions[question.QuestionName] = false;
    } else if (this.baseFormGroup.get('ExistingPolicyToBeReplaced') && this.baseFormGroup.controls['ExistingPolicyToBeReplaced'].value === 'false' && question.QuestionName === 'Owner') {
      this.visibleQuestions[question.QuestionName] = false;
    } else {
      this.visibleQuestions[question.QuestionName] = show;
    }

    if (this.isEditable) {
      const menuDataQ = find(this.sectionMenuData.questions, { 'name': question.QuestionName });
      if (menuDataQ) {
        menuDataQ.visible = show;
      }
    }

    if (question.ChildQuestions) {
      const questionList = offBlockQuestions ? offBlockQuestions : this.questions;
      forEach(question.ChildQuestions, val => {
        const childQuestion = this.qcs.getQuestion(questionList, val.QuestionName);
        this.showConditionalQuestion(childQuestion, show, questionList);
      });
    }

    this.newRelicService.addPageAction('showConditionalQuestion End', { status: 'completed', appId: this.appId });
  }

  // Control Value Accessor interface
  writeValue(value: string) {
    this.totalAllocation = value;
    this.cdr.markForCheck();
  }

  // Control Value Accessor interface
  registerOnChange(fn: any) {
      this.onChange = fn;
  }

  // Control Value Accessor interface
  registerOnTouched(fn: any) {
      this.onTouched = fn;
  }

  vulTotalAllocations() {
    this.parentFormGroup.get('VULFundOtherOptionsCompound').valueChanges.pipe(debounceTime(250), distinctUntilChanged(), takeUntil(this._onDestroy)).subscribe(val => {
      this.totalAllocation = this.qs.calculateTotalAllocation(val, 'VULFundOtherPortfolioPercent');
      this.qs.updateAccumulationTotal('VULFundOtherOptionsCompound', +this.totalAllocation, this.parent);
      this.onChange(this.totalAllocation);
      this.cdr.markForCheck();
    });
    // check for closed child response and recalculate percentage
    if (this.parentFormGroup.get('VULFundOtherOptionsCompound').value.length < this.arrayLengthVulFundOther) {
      this.totalAllocation = this.qs.calculateTotalAllocation(this.baseFormGroup.getRawValue(), 'VULFundOtherPortfolioPercent');
      this.qs.updateAccumulationTotal('VULFundOtherOptionsCompound', +this.totalAllocation, this.parent);
      this.onChange(this.totalAllocation);
      this.cdr.markForCheck();
    }
    this.arrayLengthVulFundOther = this.parentFormGroup.get('VULFundOtherOptionsCompound').value.length;
  }
  
  vulBCIATotalAllocations() {
    this.parentFormGroup.get('VULSegmentFromBCIACompound').valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(val => {
      this.totalAllocation = this.qs.calculateTotalAllocation(val, 'VULSegmentFromBCIAPercent');
      this.qs.vulSegmentProceedsAllocationTotal('VULSegmentFromBCIACompound', +this.totalAllocation);
      this.onChange(this.totalAllocation);
      this.cdr.markForCheck();
    });
    // check for closed child response and recalculate percentage
    if (this.parentFormGroup.get('VULSegmentFromBCIACompound').value.length < this.arrayLengthVULSegmentFromBCIA) {
      this.totalAllocation = this.qs.calculateTotalAllocation(this.baseFormGroup.getRawValue(), 'VULSegmentFromBCIAPercent');
      this.qs.vulSegmentProceedsAllocationTotal('VULSegmentFromBCIACompound', +this.totalAllocation);
      this.onChange(this.totalAllocation);
      this.cdr.markForCheck();
    }
    this.arrayLengthVULSegmentFromBCIA = this.parentFormGroup.get('VULFundOtherOptionsCompound').value.length;
  }

  vulBHPCIATotalAllocations() {
    this.parentFormGroup.get('VULSegmentFromBHPCIACompound').valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(val => {
      this.totalAllocation = this.qs.calculateTotalAllocation(val, 'VULSegmentFromBHPCIAPercent');
      this.qs.BaseHighParCappedIndexedAccountTotal('VULSegmentFromBHPCIACompound', +this.totalAllocation);
      this.onChange(this.totalAllocation);
      this.cdr.markForCheck();      
    });
    // check for closed child response and recalculate percentage
    if (this.parentFormGroup.get('VULSegmentFromBHPCIACompound').value.length < this.arrayLengthVULSegmentFromBHPCIA) {
      this.totalAllocation = this.qs.calculateTotalAllocation(this.baseFormGroup.getRawValue(), 'VULSegmentFromBHPCIAPercent');
      this.qs.BaseHighParCappedIndexedAccountTotal('VULSegmentFromBHPCIACompound', +this.totalAllocation);
      this.onChange(this.totalAllocation);
      this.cdr.markForCheck();       
    }
    this.arrayLengthVULSegmentFromBHPCIA = this.parentFormGroup.get('VULFundOtherOptionsCompound').value.length;
  }

  //JIRA: 3476 Begin
  vulBCTYIATotalAllocations() {
    this.parentFormGroup.get('VULSegmentFromBCTYIACompound').valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(val => {
      this.totalAllocation = this.qs.calculateTotalAllocation(val, 'VULSegmentFromBCTYIAPercent');
      this.qs.BaseCappedTwoYearIndexedAccountTotal('VULSegmentFromBCTYIACompound', +this.totalAllocation);
      this.onChange(this.totalAllocation);
      this.cdr.markForCheck();      
    });
    // check for closed child response and recalculate percentage
    if (this.parentFormGroup.get('VULSegmentFromBCTYIACompound').value.length < this.arrayLengthVULSegmentFromBCTYIA) {
      this.totalAllocation = this.qs.calculateTotalAllocation(this.baseFormGroup.getRawValue(), 'VULSegmentFromBCTYIAPercent');
      this.qs.BaseCappedTwoYearIndexedAccountTotal('VULSegmentFromBCTYIACompound', +this.totalAllocation);
      this.onChange(this.totalAllocation);
      this.cdr.markForCheck();      
    }
    this.arrayLengthVULSegmentFromBCTYIA = this.parentFormGroup.get('VULFundOtherOptionsCompound').value.length;
  }

  vulHCIATotalAllocations() {
    this.parentFormGroup.get('VULSegmentFromHCIACompound').valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(val => {
      this.totalAllocation = this.qs.calculateTotalAllocation(val, 'VULSegmentFromHCIAPercent');
      this.qs.HighCappedIndexedAccountTotal('VULSegmentFromHCIACompound', +this.totalAllocation);
      this.onChange(this.totalAllocation);
      this.cdr.markForCheck();
    });
    // check for closed child response and recalculate percentage
    if (this.parentFormGroup.get('VULSegmentFromHCIACompound').value.length < this.arrayLengthVULSegmentFromHCIA) {
      this.totalAllocation = this.qs.calculateTotalAllocation(this.baseFormGroup.getRawValue(), 'VULSegmentFromHCIAPercent');
      this.qs.HighCappedIndexedAccountTotal('VULSegmentFromHCIACompound', +this.totalAllocation);
      this.onChange(this.totalAllocation);
      this.cdr.markForCheck();
    }
    this.arrayLengthVULSegmentFromHCIA = this.parentFormGroup.get('VULFundOtherOptionsCompound').value.length;
  }
  
  //JIRA: 3476 End

  vulMonthlyChargesTotalAllocations() {
    this.parentFormGroup.get('VULAllocationofMonthlyChargesCompound').valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(val => {
      this.totalAllocation = this.qs.calculateTotalAllocation(val, 'VULAllocationMonthlyChargesAccountPercent');
      this.qs.AllocationofMonthlyChargesTotal('VULAllocationofMonthlyChargesCompound', +this.totalAllocation);
      this.onChange(this.totalAllocation);
      this.cdr.markForCheck();
    });
    // check for closed child response and recalculate percentage
    if (this.parentFormGroup.get('VULAllocationofMonthlyChargesCompound').value.length < this.arrayLengthVULAllocationofMonthlyCharges) {
      this.totalAllocation = this.qs.calculateTotalAllocation(this.baseFormGroup.getRawValue(), 'VULAllocationMonthlyChargesAccountPercent');
      this.qs.AllocationofMonthlyChargesTotal('VULAllocationofMonthlyChargesCompound', +this.totalAllocation);
      this.onChange(this.totalAllocation);
      this.cdr.markForCheck();
    }
    this.arrayLengthVULAllocationofMonthlyCharges = this.parentFormGroup.get('VULFundOtherOptionsCompound').value.length;
  }

  vulAccountBalancerTotalAllocations() {
    this.parentFormGroup.get('AccountBalancerCompound').valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(val => {
      this.totalAllocation = this.qs.calculateTotalAllocation(val, 'AccountBalancerPercentage');
      this.qs.AccountBalancerTotal('AccountBalancerCompound', +this.totalAllocation);
      this.onChange(this.totalAllocation);
      this.cdr.markForCheck();
    });
    // check for closed child response and recalculate percentage
    if (this.parentFormGroup.get('AccountBalancerCompound').value.length < this.arrayLengthAccountBalancer) {
      this.totalAllocation = this.qs.calculateTotalAllocation(this.baseFormGroup.getRawValue(), 'AccountBalancerPercentage');
      this.qs.AccountBalancerTotal('AccountBalancerCompound', +this.totalAllocation);
      this.onChange(this.totalAllocation);
      this.cdr.markForCheck();
    }
    this.arrayLengthAccountBalancer = this.parentFormGroup.get('VULFundOtherOptionsCompound').value.length;
  }
}
